"use strict";
import { Svg } from "react-native-svg";
import { createIcon } from "../factories/createIcon";
export const [Search, AnimatedSearch] = createIcon({
  name: "Search",
  getIcon: (props) => <Svg viewBox="0 0 24 24" fill="none" {...props}>
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <path d="M11 17a6 6 0 1 0 0-12a6 6 0 0 0 0 12m0 2a8 8 0 1 0 0-16a8 8 0 0 0 0 16" />
        <path d="M15.32 15.29a1 1 0 0 1 1.414.005l3.975 4a1 1 0 0 1-1.418 1.41l-3.975-4a1 1 0 0 1 .004-1.414Z" />
      </g>
    </Svg>
});
